import { render, staticRenderFns } from "./AtomSection.vue?vue&type=template&id=902294fc&scoped=true"
import script from "./AtomSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AtomSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902294fc",
  null
  
)

export default component.exports